var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccountBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "account_balance"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance_2",
    d: "M5.75 16.25V10.25C5.75 10.0375 5.82192 9.85933 5.96575 9.7155C6.10958 9.57183 6.28775 9.5 6.50025 9.5C6.71292 9.5 6.89108 9.57183 7.03475 9.7155C7.17825 9.85933 7.25 10.0375 7.25 10.25V16.25C7.25 16.4625 7.17808 16.6407 7.03425 16.7845C6.89042 16.9282 6.71225 17 6.49975 17C6.28708 17 6.109 16.9282 5.9655 16.7845C5.82183 16.6407 5.75 16.4625 5.75 16.25ZM11.25 16.25V10.25C11.25 10.0375 11.3219 9.85933 11.4658 9.7155C11.6096 9.57183 11.7878 9.5 12.0003 9.5C12.2129 9.5 12.391 9.57183 12.5345 9.7155C12.6782 9.85933 12.75 10.0375 12.75 10.25V16.25C12.75 16.4625 12.6781 16.6407 12.5343 16.7845C12.3904 16.9282 12.2123 17 11.9998 17C11.7871 17 11.609 16.9282 11.4655 16.7845C11.3218 16.6407 11.25 16.4625 11.25 16.25ZM3.51925 20.5C3.30675 20.5 3.12867 20.4281 2.985 20.2842C2.84117 20.1404 2.76925 19.9622 2.76925 19.7497C2.76925 19.5371 2.84117 19.359 2.985 19.2155C3.12867 19.0718 3.30675 19 3.51925 19H20.4807C20.6932 19 20.8713 19.0719 21.015 19.2158C21.1588 19.3596 21.2307 19.5378 21.2307 19.7503C21.2307 19.9629 21.1588 20.141 21.015 20.2845C20.8713 20.4282 20.6932 20.5 20.4807 20.5H3.51925ZM16.75 16.25V10.25C16.75 10.0375 16.8219 9.85933 16.9658 9.7155C17.1096 9.57183 17.2878 9.5 17.5003 9.5C17.7129 9.5 17.891 9.57183 18.0345 9.7155C18.1782 9.85933 18.25 10.0375 18.25 10.25V16.25C18.25 16.4625 18.1781 16.6407 18.0343 16.7845C17.8904 16.9282 17.7122 17 17.4997 17C17.2871 17 17.1089 16.9282 16.9652 16.7845C16.8217 16.6407 16.75 16.4625 16.75 16.25ZM20.5193 7.5H3.40975C3.23175 7.5 3.0805 7.43783 2.956 7.3135C2.8315 7.18933 2.76925 7.03842 2.76925 6.86075V6.47025C2.76925 6.34008 2.80183 6.22783 2.867 6.1335C2.93233 6.03933 3.01833 5.96275 3.125 5.90375L11.2058 1.95C11.4554 1.8295 11.7198 1.76925 11.9988 1.76925C12.2778 1.76925 12.5429 1.8295 12.7943 1.95L20.8345 5.87875C20.9602 5.94292 21.0576 6.03267 21.1268 6.148C21.1961 6.2635 21.2307 6.3875 21.2307 6.52V6.791C21.2307 6.99567 21.1638 7.165 21.0298 7.299C20.8958 7.433 20.7256 7.5 20.5193 7.5ZM6.31525 6H17.6848L12.1348 3.30775C12.0898 3.28842 12.0448 3.27875 12 3.27875C11.9552 3.27875 11.9103 3.28842 11.8653 3.30775L6.31525 6Z",
    fill: "var(--fill-0, white)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountBalance);
export default __webpack_public_path__ + "static/media/icon-account-balance.ceb5b5f1f910fff001c012014611950d.svg";
export { ForwardRef as ReactComponent };